module.exports = __webpack_public_path__ + "fonts/NespressoLucas-LightItalic.woff?v=32d7f6bef2ab5a5d4eea005f79f3ad87";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-LightItalic.woff
// module id = 659
// module chunks = 0